import { CasePageLayout } from "src/cases/CasePageLayout";
import { CasesEllipsisMenu, CasesPage } from "src/cases/CasesPage";
import { DashboardPageParams, getUrlToCaseQueuePage } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

export const CaseQueuesPage: React.FC = () => {
  const { orgId, wsId } = useParamsDecode<DashboardPageParams>();

  return (
    <CasePageLayout
      breadcrumbLabel="Queues"
      breadcrumbHref={getUrlToCaseQueuePage({ orgId, wsId })}
      headerActions={<CasesEllipsisMenu />}
      removePadding
    >
      <CasesPage />
    </CasePageLayout>
  );
};
